import { gql } from "@apollo/client";
import { MetadataErrorFragmentDoc, MetadataFragmentDoc } from "@dashboard/graphql";

export const UPDATE_SHOP_METADATA = gql`
  mutation UpdateShopMetadata($id: ID!, $input: [MetadataInput!]!) {
    updateMetadata(id: $id, input: $input) {
      errors {
        ...MetadataError
      }
      item {
        ...Metadata
      }
    }
  }
  ${MetadataErrorFragmentDoc}
  ${MetadataFragmentDoc}
`;

export const DELETE_SHOP_METADATA = gql`
  mutation DeleteShopMetadata($id: ID!, $keys: [String!]!) {
    deleteMetadata(id: $id, keys: $keys) {
      errors {
        ...MetadataError
      }
      item {
        ...Metadata
      }
    }
  }
  ${MetadataErrorFragmentDoc}
  ${MetadataFragmentDoc}
`;

export const CREATE_PAGE = gql`
  mutation CreatePage($input: PageCreateInput!) {
    pageCreate(input: $input) {
      errors {
        field
        message
      }
      page {
        id
        title
        slug
        content
        seoTitle
        seoDescription
        isPublished
        metadata {
          key
          value
        }
        pageType {
          id
          slug
        }
      }
    }
  }
`;

export const UPDATE_PAGE = gql`
  mutation UpdatePage($id: ID!, $input: PageInput!) {
    pageUpdate(id: $id, input: $input) {
      errors {
        field
        message
      }
      page {
        id
        title
        slug
        content
        seoTitle
        seoDescription
        isPublished
        metadata {
          key
          value
        }
        pageType {
          id
          slug
        }
      }
    }
  }
`;

export const DELETE_PAGE = gql`
  mutation DeletePage($id: ID!) {
    pageDelete(id: $id) {
      errors {
        field
        message
      }
      page {
        id
        title
      }
    }
  }
`;